import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 203 326",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M86.4617 240.363C86.4617 250.083 89.5818 259.26 96.2071 266.086C102.85 272.93 111.824 276.172 121.116 276.172C130.336 276.172 139.25 272.886 145.866 266.138C152.493 259.378 155.77 250.219 155.77 240.363V86.4399C155.77 76.294 152.76 66.4339 145.959 58.9395C139.018 51.2919 129.332 47.4538 118.806 47.4538C105.354 47.4538 94.6463 53.0161 86.0457 58.9696C86.045 58.97 86.0444 58.9705 86.0437 58.9709C86.0425 58.9718 86.0412 58.9727 86.0399 58.9736L55.2367 80.2767C44.8246 87.2653 38.8121 97.8677 38.8121 109.254C38.8121 127.047 52.7852 140.732 70.0009 140.732C75.3834 140.732 81.1138 139.507 86.4617 136.746V240.363Z",
      fill: "white",
      stroke: "#FF9600",
      "stroke-width": "28.8786"
    }, null, -1)
  ])))
}
export default { render: render }